<template>
    <div class="p-3">
        <canvas ref="canvas" class="col-md-7"></canvas>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch, nextTick } from 'vue';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale);

const verticalLinePlugin = {
    id: 'verticalLinePlugin',
    afterDatasetsDraw(chart) {
        const { ctx, scales: { x, y } } = chart;
        const customLineValue = chart.options.plugins.customLineValue;

        if (customLineValue !== null) {
            const xPos = x.getPixelForValue(customLineValue);
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(xPos, y.top);
            ctx.lineTo(xPos, y.bottom);
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'black';
            ctx.stroke();
            ctx.restore();

            // Draw the label
            ctx.font = '12px Arial';
            ctx.fillStyle = 'black';
            ctx.fillText('Your Score', xPos - ctx.measureText('Your Score').width / 2, y.top + 12);
        }
    }
};

ChartJS.register(verticalLinePlugin);

export default defineComponent({
    name: 'BarChart',
    props: {
        chartData: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const canvas = ref(null);
        let chartInstance = null;

        const renderChart = () => {
            if (chartInstance) {
                chartInstance.destroy();
            }
            nextTick(() => {
                const context = canvas.value.getContext('2d');
                chartInstance = new ChartJS(context, {
                    type: 'bar',
                    data: props.chartData,
                    options: {
                        ...props.options,
                        scales: {
                            x: {
                                ticks: {
                                    callback: function (value) {
                                        return this.getLabelForValue(value).toFixed(0);
                                    }
                                }
                            }
                        },
                        plugins: {
                            customLineValue: props.options.plugins.customLineValue
                        }
                    }
                });
            });
        };

        onMounted(renderChart);

        watch(() => props.chartData, renderChart, {deep: true});

        return {canvas};
    }
});
</script>

<style scoped>
canvas {
    max-width: 800px;
    margin: auto;
}
</style>
